module.exports = __webpack_public_path__ + "img/FietskledingVoordeelNL_1-opwit.8f9053ec.png";